import React from 'react';

const TrialLicenseDisplay = (props) => {
  const { licenseInfo } = props;
  const {
    customerName,
    expirationDate,
    network,
    dongleLockedText,
  } = licenseInfo;

  return (
    <div>
      <h5 className="font-weight-bold mb-4">License Information</h5>
      <div className="card p-3 mb-3">
        <table>
          <tbody>
            <tr>
              <td colSpan={2}>
                <h5 className="text-danger mb-4">
                  Your license is a trial version and can&apos;t be renewed.
                </h5>
              </td>
            </tr>
            <tr>
              <td className="py-2"><strong>Customer Name:</strong> {customerName}</td>
            </tr>
            <tr>
              <td className="py-2"><strong>Your current Maintenance Contract is valid until:</strong> {expirationDate}</td>
            </tr>
            <tr>
              <td className="py-2"><strong>Network:</strong> {network}</td>
            </tr>
            <tr>
              <td className="py-2"><strong>USB Dongle:</strong> {dongleLockedText}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TrialLicenseDisplay;